import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ReportScheduleService {
  private url = `${environment.reportApiUrl}/report-schedule`;

  constructor(private api: ApiService) {}

  list() {
    return this.api.get(`${this.url}`);
  }

  save(data) {
    return this.api.post(`${this.url}/save`, data);
  }
}
